import { alpha, Box, Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { ErrorListProps, FormContextType, RJSFSchema, RJSFValidationError, StrictRJSFSchema } from '@rjsf/utils';

export default function ErrorListTemplate<
  T = object,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = object,
>({ errors }: ErrorListProps<T, S, F>) {
  if (!errors?.length) return null;

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        borderRadius: '12px',
        border: (theme) => `1px solid ${alpha(theme.palette.error.main, 0.4)}`,
        backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
      }}
    >
      <div className="mb-2 flex items-center gap-1.5">
        <ErrorOutlineRoundedIcon sx={{ color: 'error.main', fontSize: 20 }} />
        <Typography sx={{ fontWeight: 700, color: 'error.main' }}>Errors</Typography>
      </div>
      <Box component="ul" sx={{ m: 0, p: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        {errors.map((error: RJSFValidationError, index: number) => (
          <li key={index} className="flex items-start gap-2">
            <Box
              component="span"
              sx={{ mt: '7px', width: 5, height: 5, flex: 'none', borderRadius: '50%', backgroundColor: 'error.main' }}
            />
            <Typography variant="body2" sx={{ color: 'text.primary' }}>
              {error.stack}
            </Typography>
          </li>
        ))}
      </Box>
    </Box>
  );
}
